import React from 'react';
import { DatesListProps } from './DatesList.types';
import { DateDetails } from '../../../../types/LTSTypes';

const DatesList = (props: DatesListProps) => {
  const { datesList, onClick } = props;

  const handleOnClick = (dateDetails: DateDetails) => {
    onClick(dateDetails);
  };

  return (
    <ul className="LTSPageCommon-ul">
      {datesList.map((item, index) => (
        <li
          className={`LTSPageCommon-li LTSTrainDate-DatesList-li ${
            !item.valid ? 'LTSTrainDate-DatesList-li-invalid' : ''
          } LTSPageCommon-click-transition`}
          key={`${item.dateTitle}-${index}`}
          onClick={() => handleOnClick(item)}
        >
          <span className="LTSPageCommon-text-overflow-ellipsis">{item.dateTitle}</span>
          <span> {item.dateFormatted}</span>
        </li>
      ))}
    </ul>
  );
};

export default DatesList;
